import React from 'react'
import { Upload, X, FileText } from 'lucide-react'
import { colors, borderRadius } from '../../styles/tokens'
import { styles } from '../../styles/newQuotation.styles'

/**
 * Área de upload de arquivos
 * 
 * Responsabilidade: Gerenciar drag & drop e seleção de arquivos
 */
export default function FileUploadArea({
    files,
    onFilesChange,
    onRemoveFile,
    fileInputRef,
    disabled
}) {
    const [dragActive, setDragActive] = React.useState(false)

    const handleDrag = (e) => {
        e.preventDefault()
        e.stopPropagation()
        if (e.type === 'dragenter' || e.type === 'dragover') setDragActive(true)
        if (e.type === 'dragleave') setDragActive(false)
    }

    const handleDrop = (e) => {
        e.preventDefault()
        e.stopPropagation()
        setDragActive(false)
        const droppedFiles = Array.from(e.dataTransfer.files)
        if (droppedFiles.length > 0) {
            onFilesChange(droppedFiles)
        }
    }

    const handleFileChange = (e) => {
        const selectedFiles = Array.from(e.target.files)
        if (selectedFiles.length > 0) {
            onFilesChange(selectedFiles)
        }
    }

    if (files.length === 0) {
        return (
            <div
                onClick={() => fileInputRef.current?.click()}
                onDragEnter={handleDrag}
                onDragLeave={handleDrag}
                onDragOver={handleDrag}
                onDrop={handleDrop}
                style={styles.dropzone(dragActive)}
            >
                <input
                    ref={fileInputRef}
                    type="file"
                    onChange={handleFileChange}
                    accept="image/*,.pdf"
                    multiple
                    style={{ display: 'none' }}
                />

                <div style={{
                    width: '56px',
                    height: '56px',
                    backgroundColor: colors.background,
                    borderRadius: '50%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    margin: '0 auto 1rem'
                }}>
                    <Upload size={24} color={colors.text.muted} />
                </div>

                <p style={{
                    fontSize: '1rem',
                    fontWeight: 500,
                    color: colors.text.primary,
                    marginBottom: '0.25rem'
                }}>
                    Faça upload do arquivo da cotação
                </p>
                <p style={{ fontSize: '0.875rem', color: colors.text.secondary }}>
                    PDF ou imagens (JPG, PNG)
                </p>
            </div>
        )
    }

    return (
        <div style={{
            display: 'flex',
            flexDirection: 'column',
            gap: '0.5rem',
            opacity: disabled ? 0.6 : 1
        }}>
            {files.map((file, index) => (
                <div key={index} style={styles.fileItem}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem' }}>
                        <div style={{
                            width: '40px',
                            height: '40px',
                            backgroundColor: `${colors.accent}20`,
                            borderRadius: borderRadius.sm,
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center'
                        }}>
                            <FileText size={20} color={colors.accent} />
                        </div>

                        <div>
                            <p style={{
                                fontSize: '0.875rem',
                                fontWeight: 500,
                                color: colors.text.primary,
                                margin: 0
                            }}>
                                {file.name}
                            </p>
                            <p style={{
                                fontSize: '0.75rem',
                                color: colors.text.secondary,
                                margin: 0
                            }}>
                                {(file.size / 1024).toFixed(1)} KB
                            </p>
                        </div>
                    </div>

                    {!disabled && (
                        <button
                            onClick={() => onRemoveFile(index)}
                            style={{
                                background: 'none',
                                border: 'none',
                                cursor: 'pointer',
                                padding: '0.5rem',
                                color: colors.text.secondary
                            }}
                        >
                            <X size={20} />
                        </button>
                    )}
                </div>
            ))}

            {!disabled && (
                <>
                    <button
                        onClick={() => fileInputRef.current?.click()}
                        style={{
                            padding: '0.75rem',
                            border: `1px dashed ${colors.border}`,
                            borderRadius: borderRadius.sm,
                            backgroundColor: 'transparent',
                            color: colors.text.secondary,
                            cursor: 'pointer',
                            fontSize: '0.875rem'
                        }}
                    >
                        + Adicionar mais arquivos
                    </button>
                    <input
                        ref={fileInputRef}
                        type="file"
                        onChange={handleFileChange}
                        accept="image/*,.pdf"
                        multiple
                        style={{ display: 'none' }}
                    />
                </>
            )}
        </div>
    )
}